import { render, staticRenderFns } from "./InstitutionListFilters.vue?vue&type=template&id=2f425f3a&"
import script from "./InstitutionListFilters.vue?vue&type=script&lang=js&"
export * from "./InstitutionListFilters.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports